// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"314":"6f096c0f","319":"4c3e4fe3"}[chunkId] + ".chunk.js";
};